<div>
	<form
		class=""
		[formGroup]="form"
		novalidate
	>
		<div>
			<mat-form-field class="sdp-form-control-input-container">
				<input
					matInput
					placeholder="{{ 'sdp.label.label' | translate }}"
					type="text"
					formControlName="label"
					class="form-control"
				>
				<mat-error *ngIf="form.controls['label'].hasError('required')">
					{{ "error.message.label.required" | translate }}</mat-error>
				<mat-error *ngIf="form.controls['label'].hasError('invalidString')">
					{{ "error.message.label.invalid" | translate }}</mat-error>
			</mat-form-field>
		</div>
		<div class="sdp-gateway-edit-name-advanced">
			<button mat-raised-button type="button" color="primary" mat-button (click)="gotoStep('ip-port')">{{ "gateway.edit.advanced" | translate }}</button>
		</div>
	</form>
</div>